export const update = {
  form: {
    code: 'Customer ID',
    name: 'Company Name',
    shortName: 'Short Name',
    method: 'Method',
    update: 'Update',
    requireCode: 'Please input customer code',
    requireName: 'Please input customer name',
    requireShortName: 'Please input customer short name',
    requireMethod: 'Please input washing method',
    cancel: 'Cancel',
    invalidLetters: 'Only letters are allowed.',
    invalidNumbers: 'Only numbers are allowed.',
  },
  pageHeader: {
    title: 'Update Customer',
    back: 'Back',
  },
}
